export const ENTITY_TYPE_DATA_IDS_CONTRACT = {
  base: 'entity-type',
  logo: 'entity-logo',
  tooltip_title: 'tooltip-title',
  title: 'entity-title'
};
